// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateCreateAssociationBindingManager, ValidateCreateAssociationBindingManagerSchema } from 'api/gen/ValidateCreateAssociationBindingManager';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { ValidateUpdateAssociationBindingManager, ValidateUpdateAssociationBindingManagerSchema } from 'api/gen/ValidateUpdateAssociationBindingManager';

export const ValidateAssociationBindingManagerSchema = t.union([ValidateCreateAssociationBindingManagerSchema, ValidateUpdateAssociationBindingManagerSchema]);

export type ValidateAssociationBindingManager = t.TypeOf<typeof ValidateAssociationBindingManagerSchema>;
